var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "div",
        { staticClass: "d-flex align-stretch batch-flex" },
        [
          _c(
            "div",
            { ref: "batchGridRef", staticClass: "batch-grid flex-grow-1" },
            [
              _c("v-data-table", {
                ref: "dataTable",
                staticClass: "dark-dividers",
                attrs: {
                  headers: _vm.displayHeaders,
                  height: _vm.tableSize,
                  "items-per-page": _vm.pageSize,
                  items: _vm.items,
                  loading: _vm.loading,
                  search: _vm.search,
                  "item-class": _vm.getRowClass,
                  "loading-text": "Loading Items...Please Wait",
                  "loader-color": "orange",
                  dense: "",
                  "fixed-header": "",
                  "hide-default-footer": "",
                  "item-key": "id",
                  expanded: _vm.expanded,
                  "show-expand":
                    _vm.isTprProRetailUser &&
                    _vm.storeGroupIsSelected &&
                    !_vm.isPercentageProofStoreGroup,
                  "single-expand": false,
                  "show-select": !_vm.isEditingDisabled,
                  "disable-sort": true,
                },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.allHeaders, function (header) {
                      return {
                        key: `header.${header.value}`,
                        fn: function () {
                          return [
                            _c(
                              "div",
                              {
                                key: header.value,
                                on: {
                                  click: function ($event) {
                                    return _vm.handleSort(header)
                                  },
                                },
                              },
                              [
                                _vm._v(" " + _vm._s(header.text) + " "),
                                header.showArrow && !header.descending
                                  ? _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "white" } },
                                      [_vm._v("mdi-chevron-up")]
                                    )
                                  : _vm._e(),
                                header.showArrow && header.descending
                                  ? _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "white" } },
                                      [_vm._v("mdi-chevron-down")]
                                    )
                                  : _vm._e(),
                                header.showArrow
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticStyle: {
                                          position: "absolute",
                                          top: "0",
                                          right: "0",
                                          cursor: "pointer",
                                        },
                                        attrs: { color: "red", small: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.removeSort(header)
                                          },
                                        },
                                      },
                                      [_vm._v(" mdi-close ")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      }
                    }),
                    {
                      key: "top",
                      fn: function () {
                        return [
                          _c(
                            "v-toolbar",
                            { attrs: { flat: "", color: "toolbar" } },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "flex-right",
                                  attrs: { dense: "", align: "center" },
                                },
                                [
                                  _vm.storeGroupIsSelected &&
                                  _vm.selectedStoreParty.party_type ===
                                    "TPR_STORE_GROUP"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticStyle: {
                                            border: "1px solid #9e9e9e",
                                            "border-left": "0px",
                                            "border-right": "0px",
                                          },
                                          attrs: {
                                            height: "40",
                                            depressed: "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.storeGroupModal = true
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "white" } },
                                            [_vm._v("mdi-store")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "4" },
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.showExpanded = true
                                        },
                                        mouseleave: function ($event) {
                                          _vm.showExpanded = false
                                        },
                                      },
                                    },
                                    [
                                      _c("v-breadcrumbs", {
                                        attrs: {
                                          large: "",
                                          items: _vm.breadcrumbs,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "item",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "v-breadcrumbs-item",
                                                  {
                                                    attrs: {
                                                      href: item.href,
                                                      disabled: item.disabled,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        class: !item.disabled
                                                          ? "primary--text"
                                                          : "",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.showExpanded &&
                                                              item.expanded_text
                                                              ? item.expanded_text
                                                              : item.text
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-spacer"),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        bottom: "",
                                        "offset-y": "",
                                        "nudge-bottom": "5",
                                        value: _vm.infoMenu,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on: menu, attrs }) {
                                            return [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on: tooltip,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-badge",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      _vm.hasWarnings,
                                                                    expression:
                                                                      "hasWarnings",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  overlap: "",
                                                                  content:
                                                                    _vm
                                                                      .toolbarWarnings
                                                                      .length,
                                                                  bordered: "",
                                                                  left: "",
                                                                  color:
                                                                    _vm.toolbarWarningsColor,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "px-0",
                                                                        attrs: {
                                                                          color:
                                                                            _vm.toolbarWarningsColor,
                                                                          outlined:
                                                                            "",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              _vm.infoMenu = true
                                                                            },
                                                                        },
                                                                      },
                                                                      "v-btn",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    {
                                                                      ...tooltip,
                                                                      ...menu,
                                                                    }
                                                                  ),
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        staticClass:
                                                                          "px-0",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-information"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Info and Warnings"),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "px-2 py-1",
                                          attrs: { outlined: "" },
                                        },
                                        _vm._l(
                                          _vm.toolbarWarnings,
                                          function (alert, index) {
                                            return _c(
                                              "v-alert",
                                              {
                                                key: index,
                                                staticClass: "my-2",
                                                attrs: {
                                                  type: alert.type,
                                                  dense: "",
                                                  outlined: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(alert.message) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.isFiltered
                                    ? _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            bottom: "",
                                            "open-on-hover": "",
                                            "max-height": "300",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "v-chip",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "orange white--text ml-2",
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              color: "white",
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " mdi-filter-outline "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-capitalize",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Results for " +
                                                                _vm._s(
                                                                  _vm
                                                                    .searchValues
                                                                    .length
                                                                ) +
                                                                " search values "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "white--text ml-2",
                                                                            attrs:
                                                                              {
                                                                                icon: "",
                                                                                "x-small":
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.searchValues =
                                                                                    []
                                                                                },
                                                                            },
                                                                          },
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  small:
                                                                                    "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-close-circle"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clear Filter"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            320569755
                                          ),
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-title",
                                                {
                                                  staticClass:
                                                    "text-subtitle-2 pb-0",
                                                },
                                                [_vm._v(" Search Values: ")]
                                              ),
                                              _c(
                                                "v-list",
                                                _vm._l(
                                                  _vm.searchValues,
                                                  function (value, index) {
                                                    return _c(
                                                      "v-list-item",
                                                      { key: index },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(value) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.tprProTenants || _vm.tenant == "awg"
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "grey lighten-2",
                                          attrs: { disabled: _vm.loading },
                                          on: { click: _vm.openModal },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-table-edit"),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.$auth.tenant === "alliance-retail-group"
                                    ? _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            value: _vm.sessionMenu,
                                            bottom: "",
                                            "offset-y": "",
                                            "nudge-bottom": "5",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on: menu }) {
                                                  return [
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on: tooltip,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-btn",
                                                                    _vm._g(
                                                                      {
                                                                        staticClass:
                                                                          "grey lighten-2",
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              _vm.sessionMenu = true
                                                                            },
                                                                        },
                                                                      },
                                                                      {
                                                                        ...tooltip,
                                                                        ...menu,
                                                                      }
                                                                    ),
                                                                    [
                                                                      _vm._v(
                                                                        " Session "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "Session controls"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1000814875
                                          ),
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass:
                                                "d-flex flex-column px-2 py-1",
                                              attrs: { color: "white" },
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { right: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "grey lighten-2 my-2",
                                                                  on: {
                                                                    click:
                                                                      _vm.saveCurrentSession,
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  " Save Session "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    4255666581
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Save Current Session"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { right: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({ on }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "grey lighten-2 px-2 my-2",
                                                                  on: {
                                                                    click:
                                                                      _vm.triggerFileInput,
                                                                  },
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _vm._v(
                                                                  " Load Session "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2675128219
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "Load Session State"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.$auth.tenant === "alliance-retail-group"
                                    ? _c("input", {
                                        ref: "sessionFileInput",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          type: "file",
                                          accept: ".json",
                                        },
                                        on: { change: _vm.handleFileSelect },
                                      })
                                    : _vm._e(),
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: {
                                        "max-width": "600px",
                                        scrollable: "",
                                        persistent: "",
                                      },
                                      model: {
                                        value: _vm.showModal,
                                        callback: function ($$v) {
                                          _vm.showModal = $$v
                                        },
                                        expression: "showModal",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              staticClass:
                                                "main white--text pa-2 centered-title",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Ordering Headers"),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-form",
                                                [
                                                  _c("v-container", [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-6",
                                                          },
                                                          [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "header-column-name",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Display Order"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "draggable",
                                                              {
                                                                staticClass:
                                                                  "list-group",
                                                                attrs: {
                                                                  list: _vm.displayHeaders,
                                                                  group:
                                                                    "headers",
                                                                },
                                                                on: {
                                                                  end: _vm.onDragEnd,
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.displayHeaders,
                                                                function (
                                                                  header
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: header.value,
                                                                    },
                                                                    [
                                                                      header.value !==
                                                                      "data-table-select"
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "list-group-item",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    header.text
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-6",
                                                          },
                                                          [
                                                            _c(
                                                              "h3",
                                                              {
                                                                staticClass:
                                                                  "header-column-name",
                                                              },
                                                              [_vm._v("Hide")]
                                                            ),
                                                            _c(
                                                              "draggable",
                                                              {
                                                                staticClass:
                                                                  "list-group",
                                                                attrs: {
                                                                  list: _vm.hideHeaders,
                                                                  group:
                                                                    "headers",
                                                                },
                                                                on: {
                                                                  end: _vm.onDragEnd,
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.hideHeaders,
                                                                function (
                                                                  header
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      key: header.value,
                                                                      staticClass:
                                                                        "list-group-item",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            header.text
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-divider", {
                                            attrs: { thickness: "2" },
                                          }),
                                          _c(
                                            "v-card-actions",
                                            { staticClass: "grey lighten-4" },
                                            [
                                              _c("v-spacer"),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "main white--text",
                                                  },
                                                  on: {
                                                    click: _vm.resetHeaders,
                                                  },
                                                },
                                                [_vm._v("Reset")]
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color:
                                                      "green darken-1 white--text",
                                                  },
                                                  on: {
                                                    click: _vm.saveHeadersOrder,
                                                  },
                                                },
                                                [_vm._v("Save")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        "close-on-content-click": false,
                                        "nudge-bottom": 3,
                                        value: _vm.srpMenu,
                                        bottom: "",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on: menu, attrs }) {
                                            return [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on: tooltip,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "grey lighten-2",
                                                                    attrs: {
                                                                      disabled:
                                                                        !_vm
                                                                          .selected
                                                                          .length ||
                                                                        _vm.isEditingDisabled ||
                                                                        _vm.isReadOnlyUser,
                                                                      readonly:
                                                                        !_vm
                                                                          .selected
                                                                          .length,
                                                                      small: "",
                                                                      height:
                                                                        "38",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.openBulkMenu,
                                                                    },
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                {
                                                                  ...tooltip,
                                                                  ...menu,
                                                                }
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-pencil-box-multiple-outline"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [_c("span", [_vm._v("Edit")])]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticClass: "fill",
                                          attrs: { width: "200" },
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            {
                                              staticClass:
                                                "pb-0 text-subtitle-1",
                                            },
                                            [_vm._v(" Edit ")]
                                          ),
                                          _c(
                                            "v-form",
                                            {
                                              ref: "form",
                                              staticClass: "px-4 pt-4",
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  rules: _vm.multiplierRules,
                                                  "background-color": "input",
                                                  dense: "",
                                                  label: "Multiplier",
                                                  outlined: "",
                                                  type: "number",
                                                },
                                                model: {
                                                  value: _vm.multiplier,
                                                  callback: function ($$v) {
                                                    _vm.multiplier = $$v
                                                  },
                                                  expression: "multiplier",
                                                },
                                              }),
                                              _c("v-text-field", {
                                                attrs: {
                                                  rules: _vm.srpRules,
                                                  "background-color": "input",
                                                  dense: "",
                                                  label: "SRP",
                                                  outlined: "",
                                                  placeholder: "0.00",
                                                  autofocus: "",
                                                  prefix: "$",
                                                  type: "number",
                                                },
                                                on: {
                                                  blur: function ($event) {
                                                    return _vm.handleSRPBlur(
                                                      null,
                                                      $event
                                                    )
                                                  },
                                                  keydown: function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    return _vm.bulkUpdate.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.srp,
                                                  callback: function ($$v) {
                                                    _vm.srp = $$v
                                                  },
                                                  expression: "srp",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-card-actions",
                                            { staticClass: "fill" },
                                            [
                                              _c("v-spacer"),
                                              _c(
                                                "v-btn",
                                                {
                                                  class: _vm.body,
                                                  attrs: { text: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      ;(_vm.srp = ""),
                                                        (_vm.srpMenu = false)
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Cancel ")]
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "blue white--text mr-2",
                                                  class: _vm.body,
                                                  on: { click: _vm.bulkUpdate },
                                                },
                                                [_vm._v(" Update ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.tenant !== "alliance-retail-group" &&
                                  _vm.tenant !== "awg"
                                    ? _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-bottom": 3,
                                            value: _vm.deleteMenu,
                                            bottom: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({
                                                  on: menu,
                                                  attrs,
                                                }) {
                                                  return [
                                                    _c(
                                                      "v-tooltip",
                                                      {
                                                        attrs: { top: "" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "activator",
                                                              fn: function ({
                                                                on: tooltip,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "v-btn",
                                                                    _vm._g(
                                                                      _vm._b(
                                                                        {
                                                                          staticClass:
                                                                            "grey lighten-2",
                                                                          attrs:
                                                                            {
                                                                              disabled:
                                                                                !_vm
                                                                                  .selected
                                                                                  .length ||
                                                                                _vm.isEditingDisabled,
                                                                              readonly:
                                                                                !_vm
                                                                                  .selected
                                                                                  .length,
                                                                              small:
                                                                                "",
                                                                              height:
                                                                                "38",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.deleteMenu = true
                                                                              },
                                                                          },
                                                                        },
                                                                        "v-btn",
                                                                        attrs,
                                                                        false
                                                                      ),
                                                                      {
                                                                        ...tooltip,
                                                                        ...menu,
                                                                      }
                                                                    ),
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-trash-can-outline"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v("Delete"),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            640225187
                                          ),
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass: "fill",
                                              attrs: { width: "200" },
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass:
                                                    "black--text text-subtitle-1",
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _vm._v(
                                                    " Delete " +
                                                      _vm._s(
                                                        _vm.selected.length
                                                      ) +
                                                      " items? "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-card-actions",
                                                { staticClass: "fill" },
                                                [
                                                  _c("v-spacer"),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      class: _vm.body,
                                                      attrs: { text: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.deleteMenu = false
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Cancel ")]
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "red white--text mr-2",
                                                      class: _vm.body,
                                                      on: {
                                                        click: _vm.bulkDelete,
                                                      },
                                                    },
                                                    [_vm._v(" Delete ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.tprProTenants
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            loading: _vm.loading,
                                            disabled:
                                              _vm.hasInvalidInputs ||
                                              _vm.isEditingDisabled ||
                                              _vm.isReadOnlyUser,
                                            color: "success",
                                          },
                                          on: { click: _vm.prepareToSave },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi-content-save")]
                                          ),
                                          _vm._v(" Save "),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.storeGroupIsSelected
                                    ? _c(
                                        "v-btn-toggle",
                                        {
                                          attrs: { mandatory: "" },
                                          model: {
                                            value: _vm.saveMethodToggle,
                                            callback: function ($$v) {
                                              _vm.saveMethodToggle = $$v
                                            },
                                            expression: "saveMethodToggle",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on: tooltip,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {},
                                                            { ...tooltip }
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-content-save-all"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4124680848
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Automatically Save Changes to Child Rows"
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on: tooltip,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            {},
                                                            { ...tooltip }
                                                          ),
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "mdi-content-save"
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2770125500
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Save Only to Focal Row"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.tprProTenants && _vm.hasActiveChanges
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "ml-2",
                                          attrs: {
                                            color: "red",
                                            loading: _vm.loading,
                                          },
                                          on: { click: _vm.refreshPage },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [_vm._v("mdi-refresh-circle")]
                                          ),
                                          _vm._v(" Reset All "),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  !_vm.isTprProRetailUser
                                    ? _c("v-text-field", {
                                        staticClass: "pp-keyword-search",
                                        staticStyle: { "max-width": "230px" },
                                        attrs: {
                                          label: "Search results",
                                          "prepend-inner-icon": "mdi-magnify",
                                          "hide-details": "",
                                          dense: "",
                                          outlined: "",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function ($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search",
                                        },
                                      })
                                    : _vm._e(),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "grey lighten-2",
                                      attrs: { height: "38" },
                                      on: {
                                        click: function ($event) {
                                          _vm.filterDrawer = !_vm.filterDrawer
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v("mdi-filter-variant"),
                                      ]),
                                      _vm._v(" Filters "),
                                      _vm.activeFilterCount
                                        ? _c("v-badge", {
                                            staticClass: "ml-1",
                                            attrs: {
                                              inline: "",
                                              content: _vm.activeFilterCount,
                                              color: "primary",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticStyle: { width: "10px" } }),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on: tooltip }) {
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.showRemoveSortsButton,
                                                        expression:
                                                          "showRemoveSortsButton",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "red lighten-1",
                                                    attrs: {
                                                      small: "",
                                                      height: "38",
                                                    },
                                                    on: {
                                                      click: _vm.removeAllSorts,
                                                    },
                                                  },
                                                  tooltip
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: { color: "white" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "mdi-sort-variant-remove"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Remove all custom ordering"),
                                      ]),
                                    ]
                                  ),
                                  _c(
                                    "v-menu",
                                    {
                                      attrs: {
                                        bottom: "",
                                        "nudge-bottom": 3,
                                        "close-on-content-click": false,
                                        value: _vm.actionMenu,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on: menu, attrs }) {
                                            return [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on: tooltip,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "grey lighten-2",
                                                                    attrs: {
                                                                      disabled:
                                                                        _vm.isSyncing,
                                                                      small: "",
                                                                      height:
                                                                        "38",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.actionMenu = true
                                                                        },
                                                                    },
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                {
                                                                  ...tooltip,
                                                                  ...menu,
                                                                }
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-cog-outline"
                                                                  ),
                                                                ]),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Batch Actions"),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c(
                                        "v-card",
                                        { staticClass: "fill" },
                                        [
                                          _c(
                                            "v-list",
                                            { staticClass: "fill" },
                                            _vm._l(
                                              _vm.actions,
                                              function (action, index) {
                                                return _c(
                                                  "v-list-item",
                                                  {
                                                    key: index,
                                                    attrs: { link: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return action.method(
                                                          _vm.selectedBatch,
                                                          _vm.primaryStore
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-icon",
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v(
                                                            _vm._s(action.icon)
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(action.text)
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-divider"),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "loading",
                      fn: function () {
                        return [
                          _c("v-container", { staticClass: "ml-0" }, [
                            _vm._v(" Loading Items...Please Wait "),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: `header.data-table-select`,
                      fn: function ({ on, props }) {
                        return [
                          _c(
                            "v-simple-checkbox",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    ripple: false,
                                    disabled: _vm.isEditingDisabled,
                                    dark: "",
                                  },
                                },
                                "v-simple-checkbox",
                                props,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.group_manager_modified`,
                      fn: function ({ item, on }) {
                        return [
                          _c(
                            "v-simple-checkbox",
                            _vm._g(
                              {
                                attrs: {
                                  value: item.group_manager_modified === true,
                                  ripple: false,
                                },
                              },
                              on
                            )
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.excluded`,
                      fn: function ({ item, on }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              key: `excluded-${item.item_id}`,
                              attrs: {
                                disabled: !_vm.getExclusionReason(item),
                                top: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on: tooltipOn }) {
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            { staticClass: "d-inline-flex" },
                                            tooltipOn
                                          ),
                                          [
                                            _c(
                                              "v-simple-checkbox",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    value:
                                                      item.excluded === "" ||
                                                      item.excluded === null,
                                                    ripple: false,
                                                    disabled:
                                                      _vm.isEditingDisabled ||
                                                      _vm.isReadOnlyUser,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleExcluded(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                on
                                              )
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getExclusionReason(item))),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.rules_applied`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                top: "",
                                disabled: !_vm.hasRules(item.rules_applied),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _vm.hasRules(item.rules_applied)
                                          ? _c(
                                              "v-icon",
                                              _vm._g(
                                                { attrs: { color: "success" } },
                                                on
                                              ),
                                              [_vm._v(" mdi-check-circle ")]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm.hasRules(item.rules_applied)
                                ? _c(
                                    "v-card",
                                    { attrs: { width: "300" } },
                                    [
                                      _c(
                                        "v-card-title",
                                        { staticClass: "text-subtitle-2" },
                                        [_vm._v("Applied Rules")]
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-list",
                                        { attrs: { dense: "" } },
                                        _vm._l(
                                          _vm.parseRules(item.rules_applied),
                                          function (rule, index) {
                                            return _c(
                                              "v-list-item",
                                              { key: index },
                                              [
                                                _c(
                                                  "v-list-item-content",
                                                  { staticClass: "pl-4" },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        "Rule: " +
                                                          _vm._s(
                                                            rule.displayLabel
                                                          )
                                                      ),
                                                    ]),
                                                    _c("v-list-item-subtitle", [
                                                      _vm._v(
                                                        "Level: " +
                                                          _vm._s(
                                                            _vm.getRuleDisplay(
                                                              rule.level
                                                            )
                                                          )
                                                      ),
                                                    ]),
                                                    rule.priority != 52
                                                      ? _c(
                                                          "v-list-item-subtitle",
                                                          [
                                                            _vm._v(
                                                              "Value: " +
                                                                _vm._s(
                                                                  rule.displayValue
                                                                )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.enforce_compliance`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-tooltip",
                            {
                              key: `compliance-${item.item_id}`,
                              attrs: {
                                disabled: !item.enforce_compliance,
                                top: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              attrs: {
                                                color: item.enforce_compliance
                                                  ? "green"
                                                  : "grey lighten-1",
                                              },
                                            },
                                            on
                                          ),
                                          [_vm._v(" mdi-shield-check-outline ")]
                                        ),
                                        _vm.tprProTenants &&
                                        item.enforce_compliance
                                          ? _c(
                                              "v-icon",
                                              _vm._g(
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !_vm.srpIsCompliant(
                                                          item
                                                        ),
                                                      expression:
                                                        "!srpIsCompliant(item)",
                                                    },
                                                  ],
                                                  attrs: {
                                                    color:
                                                      _vm.getWarningColor(item),
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " mdi-exclamation-thick "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", [_vm._v("Compliance Enforced")]),
                              _c("br"),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    "Variance: $" +
                                      parseFloat(item.variance).toFixed(2)
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.upc`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(item.upc > 2 ? item.upc : "")),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.cost`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" + _vm._s(_vm.formatCurrencyDisplay(item.cost))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.case_freight`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  item.case_freight
                                    ? _vm.formatCurrencyDisplay(
                                        item.case_freight
                                      )
                                    : _vm.formatCurrencyDisplay(item.cost)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.amap_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(item.amap_allowance)
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.dsd_oi_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.dsd_oi_allowance
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.early_buy_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.early_buy_allowance
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.tpr_billback_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.tpr_billback_allowance
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.tpr_scan_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.tpr_scan_allowance
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.tpr_scan_epay_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: { "white-space": "nowrap" },
                              },
                              [
                                item.tpr_scan_epay_allowance !== "N/A"
                                  ? _c("span", [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.formatCurrencyDisplay(
                                              item.tpr_scan_epay_allowance
                                            )
                                          )
                                      ),
                                    ])
                                  : _c("span", [_vm._v("N/A")]),
                                item.tpr_scan_epay_allowance &&
                                item.tpr_scan_epay_allowance !== "N/A" &&
                                item.tpr_scan_epay_allowance > 0 &&
                                _vm.$auth.tenant === "alliance-retail-group"
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          color: "blue",
                                                          small: "",
                                                        },
                                                        on: {
                                                          mouseenter: function (
                                                            $event
                                                          ) {
                                                            return _vm.loadPromotionData(
                                                              item,
                                                              "tpr_scan_epay"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [_vm._v("TPR Scan ePay")]
                                          ),
                                          _c("br"),
                                          _vm.loadingPromoPrice &&
                                          _vm.selectedPromotionCategory ===
                                            "tpr_scan_epay" &&
                                          _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "Loading promotion data..."
                                                ),
                                              ])
                                            : _vm.promoPromotionPriceData &&
                                              _vm.promoPromotionPriceData
                                                .promotion_price &&
                                              _vm.selectedPromotionCategory ===
                                                "tpr_scan_epay" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  " Promotion Price: $" +
                                                    _vm._s(
                                                      _vm.formatCurrencyDisplay(
                                                        _vm
                                                          .promoPromotionPriceData
                                                          .promotion_price
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm.selectedPromotionCategory ===
                                                "tpr_scan_epay" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "No promotion price found"
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "Hover to load promotion data"
                                                ),
                                              ]),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.tpr_scan_compete_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: { "white-space": "nowrap" },
                              },
                              [
                                item.tpr_scan_compete_allowance !== "N/A"
                                  ? _c("span", [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.formatCurrencyDisplay(
                                              item.tpr_scan_compete_allowance
                                            )
                                          )
                                      ),
                                    ])
                                  : _c("span", [_vm._v("N/A")]),
                                item.tpr_scan_compete_allowance &&
                                item.tpr_scan_compete_allowance !== "N/A" &&
                                item.tpr_scan_compete_allowance > 0 &&
                                _vm.$auth.tenant === "alliance-retail-group"
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          color: "blue",
                                                          small: "",
                                                        },
                                                        on: {
                                                          mouseenter: function (
                                                            $event
                                                          ) {
                                                            return _vm.loadPromotionData(
                                                              item,
                                                              "tpr_scan_compete"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [_vm._v("TPR Scan Compete")]
                                          ),
                                          _c("br"),
                                          _vm.loadingPromoPrice &&
                                          _vm.selectedPromotionCategory ===
                                            "tpr_scan_compete" &&
                                          _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "Loading promotion data..."
                                                ),
                                              ])
                                            : _vm.promoPromotionPriceData &&
                                              _vm.promoPromotionPriceData
                                                .promotion_price &&
                                              _vm.selectedPromotionCategory ===
                                                "tpr_scan_compete" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  " Promotion Price: $" +
                                                    _vm._s(
                                                      _vm.formatCurrencyDisplay(
                                                        _vm
                                                          .promoPromotionPriceData
                                                          .promotion_price
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm.selectedPromotionCategory ===
                                                "tpr_scan_compete" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "No promotion price found"
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "Hover to load promotion data"
                                                ),
                                              ]),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.edlc_billback_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.edlc_billback_allowance
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.edlc_scan_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.edlc_scan_allowance
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.edlc_scan_epay_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: { "white-space": "nowrap" },
                              },
                              [
                                item.edlc_scan_epay_allowance !== "N/A"
                                  ? _c("span", [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.formatCurrencyDisplay(
                                              item.edlc_scan_epay_allowance
                                            )
                                          )
                                      ),
                                    ])
                                  : _c("span", [_vm._v("N/A")]),
                                item.edlc_scan_epay_allowance &&
                                item.edlc_scan_epay_allowance !== "N/A" &&
                                item.edlc_scan_epay_allowance > 0 &&
                                _vm.$auth.tenant === "alliance-retail-group"
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          color: "blue",
                                                          small: "",
                                                        },
                                                        on: {
                                                          mouseenter: function (
                                                            $event
                                                          ) {
                                                            return _vm.loadPromotionData(
                                                              item,
                                                              "edlc_scan_epay"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [_vm._v("EDLC Scan ePay")]
                                          ),
                                          _c("br"),
                                          _vm.loadingPromoPrice &&
                                          _vm.selectedPromotionCategory ===
                                            "edlc_scan_epay" &&
                                          _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "Loading promotion data..."
                                                ),
                                              ])
                                            : _vm.promoPromotionPriceData &&
                                              _vm.promoPromotionPriceData
                                                .promotion_price &&
                                              _vm.selectedPromotionCategory ===
                                                "edlc_scan_epay" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  " Promotion Price: $" +
                                                    _vm._s(
                                                      _vm.formatCurrencyDisplay(
                                                        _vm
                                                          .promoPromotionPriceData
                                                          .promotion_price
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm.selectedPromotionCategory ===
                                                "edlc_scan_epay" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "No promotion price found"
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "Hover to load promotion data"
                                                ),
                                              ]),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.edlc_scan_compete_allowance`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center",
                                staticStyle: { "white-space": "nowrap" },
                              },
                              [
                                item.edlc_scan_compete_allowance !== "N/A"
                                  ? _c("span", [
                                      _vm._v(
                                        "$" +
                                          _vm._s(
                                            _vm.formatCurrencyDisplay(
                                              item.edlc_scan_compete_allowance
                                            )
                                          )
                                      ),
                                    ])
                                  : _c("span", [_vm._v("N/A")]),
                                item.edlc_scan_compete_allowance &&
                                item.edlc_scan_compete_allowance !== "N/A" &&
                                item.edlc_scan_compete_allowance > 0 &&
                                _vm.$auth.tenant === "alliance-retail-group"
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          color: "blue",
                                                          small: "",
                                                        },
                                                        on: {
                                                          mouseenter: function (
                                                            $event
                                                          ) {
                                                            return _vm.loadPromotionData(
                                                              item,
                                                              "edlc_scan_compete"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        " mdi-information "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [_vm._v("EDLC Scan Compete")]
                                          ),
                                          _c("br"),
                                          _vm.loadingPromoPrice &&
                                          _vm.selectedPromotionCategory ===
                                            "edlc_scan_compete" &&
                                          _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "Loading promotion data..."
                                                ),
                                              ])
                                            : _vm.promoPromotionPriceData &&
                                              _vm.promoPromotionPriceData
                                                .promotion_price &&
                                              _vm.selectedPromotionCategory ===
                                                "edlc_scan_compete" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  " Promotion Price: $" +
                                                    _vm._s(
                                                      _vm.formatCurrencyDisplay(
                                                        _vm
                                                          .promoPromotionPriceData
                                                          .promotion_price
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _vm.selectedPromotionCategory ===
                                                "edlc_scan_compete" &&
                                              _vm.selectedPromotionItem === item
                                            ? _c("span", [
                                                _vm._v(
                                                  "No promotion price found"
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  "Hover to load promotion data"
                                                ),
                                              ]),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.unit_cost`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(item.unit_cost)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.net_unit_cost`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(item.net_unit_cost)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "item.gross_profit",
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                item.gross_profit != null
                                  ? item.gross_profit.toFixed(2) + "%"
                                  : ""
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.net_gross_profit`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(_vm._f("format")(item.net_gross_profit)) +
                                "%"
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.retail_price`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(item.retail_price)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.unit_savings`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.calculateUnitSavings(item).toFixed(2)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.obxi`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(item.obxi)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.like_code`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(item.like_code)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.linked_group`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            item.linked_group && _vm.showLinkedGroupLink
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "primary--text cursor-pointer text-decoration-underline",
                                    attrs: {
                                      title: `Filter by Linked Group: ${item.linked_group}`,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.filterByLinkedGroup(
                                          item.linked_group
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(item.linked_group) + " "
                                    ),
                                  ]
                                )
                              : _c("span", [
                                  _vm._v(_vm._s(item.linked_group || "")),
                                ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.start_dt`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(_vm.formatDateDisplay(item.start_dt))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.end_dt`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(_vm.formatDateDisplay(item.end_dt))),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.store_name`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(item.store_name)),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.updated_on`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(_vm.formatDateTimestamp(item.updated_on))
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.rules_promotion_price`,
                      fn: function ({ item }) {
                        return [
                          item.rules_promotion_price
                            ? _c("td", { staticClass: "noWrap" }, [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.rules_promotion_price
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.original_promotion_price`,
                      fn: function ({ item }) {
                        return [
                          item.original_promotion_price
                            ? _c("td", { staticClass: "noWrap" }, [
                                _vm._v(
                                  " $" +
                                    _vm._s(
                                      _vm.formatCurrencyDisplay(
                                        item.original_promotion_price
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.promotion_price`,
                      fn: function ({ item, index }) {
                        return [
                          _c("BatchSrpCell", {
                            attrs: {
                              item: item,
                              index: index,
                              "is-editing-disabled": _vm.isEditingDisabled,
                              "srp-exceeds-base-retail":
                                _vm.srpExceedsBaseRetail(item),
                              "tpr-pro-tenants": _vm.tprProTenants,
                              "has-selections": _vm.hasSelections,
                              "srp-rules": _vm.srpRules,
                              "is-changed": _vm.changedItemIds.has(item.id),
                            },
                            on: {
                              "multiplier-change": _vm.onMultiplierChange,
                              "gp-recompute": _vm.debouncedUpdateGrossProfit,
                              "handle-input": _vm.onHandleInput,
                              "srp-blur": _vm.onSrpBlur,
                              "srp-change": _vm.onSrpChange,
                              enter: _vm.onEnter,
                              "show-linked-group": _vm.showLinkedGroupModal,
                              reset: _vm.resetRow,
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: `item.total_allowance_per_unit`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  Number(item.total_allowance_per_unit).toFixed(
                                    2
                                  )
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.srp_needed_to_maintain_margin`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  Number(
                                    item.srp_needed_to_maintain_margin
                                  ).toFixed(2)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.difference_to_regular_price`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "noWrap",
                              class: {
                                "red--text":
                                  _vm.calculateDifferenceToRegularPrice(item) >
                                  0,
                              },
                            },
                            [
                              _vm._v(
                                " $" +
                                  _vm._s(
                                    _vm
                                      .calculateDifferenceToRegularPrice(item)
                                      .toFixed(2)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                    {
                      key: `item.prev_msu`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(item.prev_msu || "---")),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.prev_retail`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.prev_retail
                                  ? `$${_vm.formatCurrencyDisplay(
                                      item.prev_retail
                                    )}`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.prev_margin`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.prev_margin
                                  ? `${item.prev_margin}%`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.prev_net_unit_cost`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.prev_net_unit_cost
                                  ? `$${_vm.formatCurrencyDisplay(
                                      item.prev_net_unit_cost
                                    )}`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.previous_tpr_cost`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.previous_tpr_cost
                                  ? `$${_vm.formatCurrencyDisplay(
                                      item.previous_tpr_cost
                                    )}`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.previous_tpr_msu`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(item.previous_tpr_msu || "---")),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.previous_tpr_retail`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.previous_tpr_retail
                                  ? `$${_vm.formatCurrencyDisplay(
                                      item.previous_tpr_retail
                                    )}`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.previous_tpr_margin`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.previous_tpr_margin
                                  ? `${item.previous_tpr_margin}%`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.current_tpr_msu`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(_vm._s(item.current_tpr_msu || "---")),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.current_tpr_retail`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.current_tpr_retail
                                  ? `$${_vm.formatCurrencyDisplay(
                                      item.current_tpr_retail
                                    )}`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.current_tpr_end_date`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.current_tpr_end_date
                                  ? _vm.formatDateDisplay(
                                      item.current_tpr_end_date
                                    )
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.length_of_tpr`,
                      fn: function ({ item }) {
                        return [
                          _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              _vm._s(
                                item.length_of_tpr
                                  ? `${item.length_of_tpr} days`
                                  : "---"
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                    _vm._l(_vm.compPricingModes, function (index) {
                      return {
                        key: `item.comp_pricing_${index}`,
                        fn: function ({ item }) {
                          return [
                            _c("td", { key: index, staticClass: "noWrap" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center" },
                                [
                                  _vm.getCompetitorPrice(item, index) !== "N/A"
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          attrs: { bottom: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _vm.tprProTenants
                                                      ? _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    _vm.getPriceComparisonColor(
                                                                      item,
                                                                      index
                                                                    ),
                                                                },
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.getPriceComparisonIcon(
                                                                    item,
                                                                    index
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getPriceComparisonText(
                                                  item,
                                                  index
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("span", { staticClass: "ml-2" }, [
                                    _vm.getCompetitorPrice(item, index) !==
                                    "N/A"
                                      ? _c("span", [
                                          _vm._v(
                                            "$" +
                                              _vm._s(
                                                _vm.formatCurrencyDisplay(
                                                  _vm.getCompetitorPrice(
                                                    item,
                                                    index
                                                  )
                                                )
                                              )
                                          ),
                                        ])
                                      : _c("span", [_vm._v("N/A")]),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                          ]
                        },
                      }
                    }),
                    {
                      key: `item.promo_info`,
                      fn: function ({ item }) {
                        return [
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "close-on-content-click": false,
                                "offset-x": "",
                                "offset-y": "",
                                "open-on-click": "",
                                right: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on: menu, attrs }) {
                                      return [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function ({
                                                    on: tooltip,
                                                  }) {
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                icon: "",
                                                                tabindex: "-1",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.getPromosByRow(
                                                                      item
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          {
                                                            ...tooltip,
                                                            ...menu,
                                                          }
                                                        ),
                                                        [
                                                          _c("v-icon", [
                                                            _vm._v(
                                                              "mdi-magnify"
                                                            ),
                                                          ]),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          },
                                          [_c("span", [_vm._v("View Promos")])]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c(
                                "v-card",
                                { attrs: { width: "400" } },
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      staticClass: "accent",
                                      attrs: { flat: "", dark: "" },
                                    },
                                    [
                                      _c("v-toolbar-title", [
                                        _vm._v("Included in Allowances"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-container",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      staticStyle: {
                                        "max-height": "250px",
                                        "overflow-y": "auto",
                                      },
                                      attrs: { fluid: "" },
                                    },
                                    [
                                      _c(
                                        "v-list",
                                        {
                                          staticClass: "py-0",
                                          attrs: { dense: "" },
                                        },
                                        _vm._l(
                                          _vm.promosByRow,
                                          function (promo) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: promo.promo_id,
                                                attrs: { link: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openLink(
                                                      promo.promo_id
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-list-item-content",
                                                  {
                                                    staticClass:
                                                      "primary--text",
                                                  },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(promo.promo_name)
                                                      ),
                                                    ]),
                                                    _vm.promosByRow.length > 0
                                                      ? [
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  promo.promo_number
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm.$auth.tenant ===
                                                          "awg"
                                                            ? _c(
                                                                "v-list-item-subtitle",
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.formatDateDisplay(
                                                                          promo.promo_start_date
                                                                        )
                                                                      ) +
                                                                      " - " +
                                                                      _vm._s(
                                                                        _vm.formatDateDisplay(
                                                                          promo.promo_end_date
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      : [
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            [
                                                              _vm._v(
                                                                "No Promos to Show"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                    _vm.tenant == "alliance-retail-group"
                      ? {
                          key: `item.is_shipper`,
                          fn: function ({ item }) {
                            return [
                              item.is_shipper
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "", color: "primary" },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.selectedItem = item
                                              _vm.showComponents = true
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-view-list"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        }
                      : null,
                    {
                      key: "item.data-table-expand",
                      fn: function ({ item, isExpanded }) {
                        return [
                          item.alternate_store_items &&
                          item.alternate_store_items.length > 0
                            ? _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.retailMatchesAcrossStores(item)
                                      ? "black"
                                      : "red darken-2",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleExpansion(
                                        item,
                                        isExpanded
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      isExpanded
                                        ? "mdi-chevron-up"
                                        : "mdi-chevron-down"
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    !_vm.isTprProRetailUser
                      ? {
                          key: "expanded-item",
                          fn: function ({ item, headers }) {
                            return [
                              _c(
                                "td",
                                {
                                  staticClass: "grey lighten-3 pa-0",
                                  attrs: { colspan: headers.length },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      tabindex: "-1",
                                      "background-color": "grey lighten-3",
                                      color: "primary",
                                      dense: "",
                                      flat: "",
                                      "hide-details": "",
                                      placeholder: "Add Note",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.noteUpdate(item)
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "prepend-inner",
                                          fn: function () {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "font-weight-medium mx-3 pt-1",
                                                },
                                                [_vm._v("Note:")]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: item.note,
                                      callback: function ($$v) {
                                        _vm.$set(item, "note", $$v)
                                      },
                                      expression: "item.note",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        }
                      : _vm.isTprProRetailUser
                      ? {
                          key: "expanded-item",
                          fn: function ({ item, headers }) {
                            return [
                              _c("BatchItemAlternateStores", {
                                attrs: {
                                  headers: headers,
                                  parentCompPricingModes: _vm.compPricingModes,
                                  stores: _vm.selectedStoreParty.children,
                                  item: item,
                                  alternateStoreItems:
                                    item.alternate_store_items,
                                  selectedBatch: _vm.selectedBatch,
                                  batchItems: _vm.items,
                                  parentColumnWidths: _vm.columnWidths,
                                  isEditingDisabled: _vm.isEditingDisabled,
                                  storeGroupIsSelected:
                                    _vm.storeGroupIsSelected,
                                },
                                on: {
                                  linkedGroupUpdate: _vm.linkedGroupUpdate,
                                  alternateItemsUpdate:
                                    _vm.alternateItemsUpdate,
                                  subItemChange: _vm.handleSubItemChange,
                                  subItemsSaved: _vm.handleSubItemsSaved,
                                },
                              }),
                            ]
                          },
                        }
                      : null,
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c("v-divider"),
                          _c(
                            "v-toolbar",
                            {
                              staticStyle: {
                                "margin-top": "16px",
                                height: "56px",
                              },
                              attrs: { flat: "", color: "#fff" },
                            },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "align-center",
                                  staticStyle: { height: "100%" },
                                },
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center py-0",
                                      staticStyle: { "max-width": "150px" },
                                      attrs: { cols: "2" },
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.pageSizes,
                                          "menu-props": {
                                            top: true,
                                            offsetY: true,
                                            maxHeight: 500,
                                          },
                                          dense: "",
                                          height: "32",
                                          label: "Items Per Page",
                                        },
                                        model: {
                                          value: _vm.pageSize,
                                          callback: function ($$v) {
                                            _vm.pageSize = $$v
                                          },
                                          expression: "pageSize",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex align-center py-0",
                                      staticStyle: { "margin-top": "-26px" },
                                      attrs: { cols: "auto" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mx-2",
                                          attrs: {
                                            disabled:
                                              _vm.disablePrevious ||
                                              _vm.loading,
                                            icon: "",
                                            large: "",
                                          },
                                          on: { click: _vm.previous },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-chevron-left"),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c("small", [
                                        _vm._v("Page " + _vm._s(_vm.page)),
                                      ]),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mx-2",
                                          attrs: {
                                            disabled:
                                              _vm.disableNext || _vm.loading,
                                            icon: "",
                                            large: "",
                                          },
                                          on: { click: _vm.next },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-chevron-right"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selected,
                  callback: function ($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected",
                },
              }),
            ],
            1
          ),
          _c(
            "v-expand-x-transition",
            [
              _c("SearchFilters", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterDrawer,
                    expression: "filterDrawer",
                  },
                ],
                ref: "searchFilters",
                staticClass: "pp-filter-drawer flex-shrink-0",
                attrs: {
                  categories: _vm.categoryList,
                  subcategories: _vm.subcategoryList,
                  departments: _vm.departmentList,
                  promoCategories: _vm.promoCategoryList,
                  vendors: _vm.vendorList,
                  batch_type: _vm.selectedBatch.batch_type,
                  "panel-height": _vm.drawerHeight || _vm.tableSize,
                },
                on: {
                  input: _vm.getItems,
                  "filters-cleared": _vm.onFiltersCleared,
                  close: function ($event) {
                    _vm.filterDrawer = false
                  },
                },
                model: {
                  value: _vm.searchParams,
                  callback: function ($$v) {
                    _vm.searchParams = $$v
                  },
                  expression: "searchParams",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "400" },
          model: {
            value: _vm.showConfirmPopup,
            callback: function ($$v) {
              _vm.showConfirmPopup = $$v
            },
            expression: "showConfirmPopup",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "modalCard", attrs: { height: "220" } },
            [
              _c(
                "v-toolbar",
                { staticClass: "main", attrs: { flat: "", dark: "" } },
                [_c("v-toolbar-title", [_vm._v("Confirm SRP Values")])],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-row",
                        { staticClass: "align-center" },
                        [
                          _c("v-checkbox", {
                            attrs: {
                              id: "checkbox",
                              label:
                                "I understand that I am saving items with an SRP value that falls outside of the compliance range.",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.confirmChecked,
                              callback: function ($$v) {
                                _vm.confirmChecked = $$v
                              },
                              expression: "confirmChecked",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c("v-btn", { on: { click: _vm.cancelConfirm } }, [
                            _vm._v("Cancel"),
                          ]),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-3 green white--text",
                              attrs: { disabled: !_vm.confirmChecked },
                              on: { click: _vm.saveChanges },
                            },
                            [_vm._v(" Confirm Save ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("StoreGroupModal", {
        attrs: {
          value: _vm.storeGroupModal,
          userStores: _vm.userStores,
          storeParty: _vm.selectedStoreParty,
        },
        on: {
          "update:value": function ($event) {
            _vm.storeGroupModal = $event
          },
        },
      }),
      _c("AlertDialog", {
        attrs: {
          value: _vm.alertDialog,
          batch: _vm.selectedBatch,
          total: _vm.total,
        },
        on: {
          "update:value": function ($event) {
            _vm.alertDialog = $event
          },
          update: function ($event) {
            return _vm.batchUpdate($event)
          },
        },
      }),
      _c("AdGroupShuttle", {
        attrs: {
          value: _vm.adShuttleDialog,
          ad_group: _vm.selectedAdGroup,
          batch: _vm.selectedBatch,
          batch_changes: _vm.changesAvailableForShuttle,
          store_ids: _vm.storeGroupIsSelected
            ? _vm.selectedStoreParty.children.flatMap((p) => p.store_party_id)
            : [_vm.selectedStore.store_party_id],
        },
        on: {
          "update:value": function ($event) {
            _vm.adShuttleDialog = $event
          },
        },
      }),
      _vm.linkedGroupModal
        ? _c("LinkedGroupModal", {
            attrs: {
              value: _vm.linkedGroupModal,
              item: _vm.linkedGroupItem,
              batch: _vm.selectedBatch,
              batchItems: _vm.items,
              store: _vm.linkedGroupStore || _vm.primaryStore,
              isTprProRetailUser: _vm.isTprProRetailUser,
              storeGroupIsSelected: _vm.storeGroupIsSelected,
              propagateChangesToChildRows: _vm.propagateChangesToChildRows,
            },
            on: {
              "update:value": function ($event) {
                _vm.linkedGroupModal = $event
              },
              onSave: _vm.linkedGroupSave,
            },
          })
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { absolute: "", value: _vm.exporting } },
        [
          _c(
            "v-progress-circular",
            { attrs: { indeterminate: "", size: "100" } },
            [_vm._v(" Exporting... ")]
          ),
        ],
        1
      ),
      _vm.showComponents
        ? _c("ComponentItems", {
            attrs: {
              selectedItem: _vm.selectedItem,
              selectedBatch: _vm.selectedBatch,
            },
            on: {
              close: function ($event) {
                _vm.showComponents = false
              },
            },
            model: {
              value: _vm.showComponents,
              callback: function ($$v) {
                _vm.showComponents = $$v
              },
              expression: "showComponents",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }